import React from 'react';

interface StackProps extends React.HTMLAttributes<HTMLDivElement> {
  direction?: 'horizontal' | 'vertical';
  gap?: number;
}

const gapMap: Record<number, string> = {
  0: 'gap-0', 1: 'gap-1', 2: 'gap-2', 3: 'gap-4', 4: 'gap-6', 5: 'gap-12',
};

function Stack({ direction = 'vertical', gap, className = '', children, ...rest }: StackProps) {
  const dir = direction === 'horizontal' ? 'flex flex-row items-center' : 'flex flex-col';
  const gapClass = gap != null ? (gapMap[gap] || '') : '';
  return (
    <div className={`${dir} ${gapClass} ${className}`.trim()} {...rest}>
      {children}
    </div>
  );
}

export default Stack;
